module.exports = __webpack_public_path__ + "img/parking-space-counter.6af3bd77.svg";